/* PDP reviews carousel (snippets/cs-pdp-reviews.liquid)
   Shows one review at a time and moves to the next every data-interval ms.
   Pauses while the box is hovered or has focus, or the tab is hidden; no
   autoplay for visitors who prefer reduced motion. The dots jump to a review.
*/

class PdpReviewsCarousel extends HTMLElement {
    connectedCallback() {
        this.slides = [...this.querySelectorAll('.cs-pdp-reviews__slide')];
        this.dots = [...this.querySelectorAll('.cs-pdp-reviews__dot')];
        if (this.slides.length < 2) return;

        this.index = 0;
        this.interval = Number(this.dataset.interval) || 6000;
        this.paused = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot) => {
            dot.addEventListener('click', () => {
                this.show(Number(dot.dataset.index));
                this.start();
            });
        });

        this.pause = () => {
            this.paused = true;
            this.stop();
        };
        this.resume = () => {
            this.paused = false;
            this.start();
        };
        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.resume);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.resume();
        });

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.start();
    }

    disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
            const active = i === this.index;
            slide.classList.toggle('is-active', active);
            slide.toggleAttribute('aria-hidden', !active);
        });
        this.dots.forEach((dot, i) => {
            dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });
    }

    start() {
        this.stop();
        if (this.paused || this.reduceMotion || document.hidden) return;
        this.timer = setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
        clearInterval(this.timer);
    }
}

if (!customElements.get('pdp-reviews-carousel')) {
    customElements.define('pdp-reviews-carousel', PdpReviewsCarousel);
}
